import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=2c0a17c2&scoped=true&lang=pug&"
import script from "./tooltip.vue?vue&type=script&lang=js&"
export * from "./tooltip.vue?vue&type=script&lang=js&"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=2c0a17c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a17c2",
  null
  
)

export default component.exports